import React, {useState} from "react";
import {addNewSkill} from "../../../../service/adminService";
import {Button, ButtonToolbar, Form, Modal, SelectPicker} from "rsuite";
import {adminSkillModel} from "../../../form/models";

const AddAdminSkillModal = (props) => {
    const { open, handleClose, skillTypes } = props

    const [localState, setLocalState] = useState();

    const submitAdminSkillAdd = (isFormValid) => {
        if(!isFormValid) return;
        addNewSkill(localState).then((response) => {
            handleClose(response);
        });
    };

    // rsuite does not have an onSubmit, we must handle state changes per controlled field
    const handleFormChange = (event) => {
        setLocalState({...localState, ...event});
    }

    return (
        <Modal
            open={open}
            onClose={handleClose}
            backdrop="static"
        >
            <Modal.Header>
                <Modal.Title>Add Skill</Modal.Title>
            </Modal.Header>
            <Modal.Body>
            </Modal.Body>
            <Form
                layout="horizontal"
                model={adminSkillModel}
                onChange={handleFormChange}
                onSubmit={submitAdminSkillAdd}
            >
                <Form.Group>
                    <Form.ControlLabel>Skill Name</Form.ControlLabel>
                    <Form.Control name="skillName"/>
                </Form.Group>
                <Form.Group>
                    <Form.ControlLabel>Skill Type</Form.ControlLabel>
                    <Form.Control name="skillType"
                                  accepter={SelectPicker}
                                  data={skillTypes}
                    />
                </Form.Group>
                <Form.Group>
                    <ButtonToolbar>
                        <Button type="submit" appearance="primary">
                            Ok
                        </Button>
                        <Button onClick={handleClose} appearance="default">
                            Cancel
                        </Button>
                    </ButtonToolbar>
                </Form.Group>
            </Form>
        </Modal>
    );
};

export default AddAdminSkillModal;